export const webinar = {
  bottomCTA: {
    head: "External data should be easy to discover and deploy",
  },
  button: "Learn More",
  button_link: "",
  form: {
    header: "Please provide your name and email address to gain access to this webinar",
    fields: [
      { label: "Full name", id: "full_name", type: "text", component: "input", required: true },
      { label: "Email", id: "email", type: "email", component: "input", required: true },
    ],
  },
};
